  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('#toc ul>li>a').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = this.hash.substring(1);
        var targetElement = document.getElementById(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.getBoundingClientRect().top + window.pageYOffset - 170,
            behavior: 'smooth'
          });
        }
      });
    });
  });